import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  /** Page actions, shown on the right (wrap below the title on a phone). */
  actions?: ReactNode;
}

export const PageHeader = ({ title, description, actions }: PageHeaderProps) => (
  <div className="flex flex-wrap items-start justify-between gap-x-6 gap-y-3">
    <div className="min-w-0">
      <h2 className="text-title font-semibold text-ink">{title}</h2>
      {description && <p className="mt-1 text-body text-muted">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2 no-print">{actions}</div>}
  </div>
);
